import i18n from '@/i18n'

const cscConfirmReception = {
    namespaced: true,
    state: {
        isVisible: false,

        resolve: null,
        reject: null,

        typeOfExamination: null,
        typesOfExamination: [{ id: 1, Value: 'Первичное' }, { id: 2, Value: 'Повторное' }],
        
        address: null,
        phone: null,

    },
    mutations: {
        SET_IS_VISIBLE(state, payload) {
            state.isVisible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_TYPEOFEXAMINATION(state, payload) {
            state.typeOfExamination = payload;
        },
        SET_ADDRESS(state, payload) {
            state.address = payload;
        },
        SET_PHONE(state, payload) {
            state.phone = payload;
        },
    },
    actions: {
        async open({ commit }) {

            commit('SET_IS_VISIBLE', true);
            
            //Initialize
            commit('SET_TYPEOFEXAMINATION', null);
            commit('SET_ADDRESS', null);
            commit('SET_PHONE', null);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },

        async ok({ commit, state, rootGetters }) {
            commit('SET_IS_VISIBLE', false);

            let result =  {
                DocumentId: rootGetters['global/actionsource/getDataSource'].Data.Object.Document.id,
                PMPK_Examination: state.typeOfExamination.id,
                PMPK_Address: state.address,
                PMPK_Phone: state.phone
            };
            
            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_IS_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.isVisible,
        
        isValid: (s) => (s.typeOfExamination && s.address && s.phone),
        getTypeOfExamination: (s) => s.typeOfExamination,
        getTypesOfExamination: (s) => s.typesOfExamination.map(x => ({ id: x.id, Value: i18n.t(x.Value) })),
        getAddress: (s) => s.address,
        getPhone: (s) => s.phone,        
    }
}

export default cscConfirmReception;